export default __webpack_public_path__ + "static/media/icons8-menu-48-white.8d97e2da.svg";